const Sdata = [
    {
       heading : "Dev tools" ,
       title :"Tools i work with while coding",
       para : "These are the tools that I mainly use while coding and building something creative",
       link : require("../images/devSkill10.png")

    },

    {
        heading : "Dev Skills" ,
        title :"Languages and frameworks",
        para : "These are the languages and libraries I mainly focused on and have built some projects based on these",
        link : require("../images/tools10.png")
 
     },

     {
        heading:"Side Skills",
        link : require("../images/sideSkill10.png"),
        
        para:"When I'm not on the computer, I enjoy these things and more like reading about archaeological history and mythology of India",
        title:"What else i like to do"
     }


]

export default Sdata